import { formatAmounts } from '../../resources';
import type { GameEvent } from '../types';
import type { DiffContext } from './context';

/**
 * The player's latest plunder of a rival city and razing of rival buildings
 * (PlayerState.lastPlunder / lastRaze), when new. A fallen city is both razed
 * and plundered in one tick: it's reported once, the raze reward added to
 * the plunder.
 */
export function plunderEvents(c: DiffContext): GameEvent[] {
  const { prev, next, playerId } = c;
  const events: GameEvent[] = [];
  const plunder = next.plunders.get(playerId);
  const newPlunder = plunder && plunder.tick !== prev.plunders.get(playerId)?.tick;
  const raze = next.razes.get(playerId);
  const newRaze = raze && raze.tick !== prev.razes.get(playerId)?.tick;
  const cityRaze =
    newPlunder &&
    newRaze &&
    raze.count === 1 &&
    raze.tick === plunder.tick &&
    raze.pos.q === plunder.pos.q &&
    raze.pos.r === plunder.pos.r;
  if (newPlunder) {
    const amounts = { ...plunder.amounts };
    if (cityRaze) {
      for (const [res, amount] of Object.entries(raze.amounts)) {
        amounts[res] = (amounts[res] ?? 0) + amount;
      }
    }
    const gained = formatAmounts(amounts);
    events.push({
      kind: 'plunder',
      text: gained ? `Plundered ${plunder.from}: +${gained}` : `Plundered ${plunder.from}`,
      pos: plunder.pos,
    });
  }
  if (newRaze && !cityRaze) {
    const gained = formatAmounts(raze.amounts);
    const what =
      raze.count > 1 ? `${raze.count} rival buildings` : `rival ${c.buildingName(raze.type)}`;
    events.push({
      kind: 'plunder',
      text: gained ? `Razed ${what}: +${gained}` : `Razed ${what}`,
      pos: raze.pos,
    });
  }
  return events;
}
